import config from 'configDir/index';
import { get } from './http';

// 里程分析趋势
const fiveMileageAllService = get('/five/analysis/mileage/all', config.discoveryCenterServiceUrl);

export {
  // eslint-disable-next-line import/prefer-default-export
  fiveMileageAllService,
};
